import React from "react";

import {
  View,
  StatusBar,
  ScrollView,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
} from "react-native";
import { Text, Icon, ImgIcon, Logout } from "components";

import ItsaLink from "./ItsaLink";
import DrawerHeader from "./DrawerHeader";

import { colors, sizes, strings } from "assets/constants";

import css from "styles";
import { useChmod } from "hooks";
import { authAtom } from "stores";
import { useRecoilValue } from "recoil";

import { COMPANY_SECTIONS, SUPER_ADMIN_SECTIONS } from "./itemsInfo";
import tinycolor from "tinycolor2";

export default function Content() {
  const { chmod } = useChmod();
  const user = useRecoilValue(authAtom);

  return (
    <>
      <SafeAreaView style={styles.container}>
        <DrawerHeader />

        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={css.growContainer}
        >
          {user?.role === strings.super_admin
            ? SUPER_ADMIN_SECTIONS.map((section, key) => {
                return (
                  <View key={String(key)}>
                    <View style={styles.title}>
                      <Icon
                        size={15}
                        type="ion"
                        name={"ellipse"}
                        color={colors.dark._13}
                      />

                      <Text weight="bold" top={0}>
                        {" "}
                        {section?.title}
                      </Text>
                    </View>
                    {section.contents?.map((content, uniqKey) => {
                      return (
                        <TouchableOpacity
                          onPress={content.nav}
                          style={styles.link}
                          key={String(uniqKey)}
                        >
                          <Icon
                            size={15}
                            type="materialCommunity"
                            name={content.icon}
                            color={colors.theme}
                          />
                          <Text> {content.title}</Text>
                        </TouchableOpacity>
                      );
                    })}
                  </View>
                );
              })
            : COMPANY_SECTIONS(
                chmod("company", "GET"),
                chmod("wholesalers", "GET"),
                chmod("customer", "GET"),
                chmod("factor", "GET"),
                chmod("reminder", "GET"),
                chmod("note", "GET"),
                chmod("attribute", "GET"),
                chmod("category", "GET"),
                chmod("product", "GET"),
                chmod("frindship", "GET"),
                chmod("report", "GET")
              )?.map((section, key) => {
                return section.perm ? (
                  <React.Fragment key={String(key)}>
                    <TouchableOpacity
                      onPress={section.nav}
                      style={styles.link}
                      key={String(key)}
                    >
                      <View
                        style={{
                          width: 30,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ImgIcon
                          size={section?.iconSize || 18}
                          icon={section.icon}
                          color={tinycolor(colors.theme).lighten(25).toString()}
                        />
                      </View>
                      <Text weight="bold">{section.title}</Text>
                    </TouchableOpacity>
                    <View
                      style={{
                        width: "70%",
                        height: 1,
                        alignSelf: "center",
                        backgroundColor: tinycolor(colors.theme)
                          .lighten(52)
                          .toString(),
                      }}
                    />
                  </React.Fragment>
                ) : null;
              })}

          <View style={{ paddingHorizontal: sizes.space * 2 }}>
            <Logout />
          </View>
          <View style={css.container} />
          <ItsaLink />
        </ScrollView>
      </SafeAreaView>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: "hidden",
    height: sizes.screenH,
    paddingTop: StatusBar.currentHeight + sizes.space,
  },

  title: {
    flexDirection: "row-reverse",
    alignItems: "center",
    paddingHorizontal: sizes.space,
    paddingTop: sizes.space,
    paddingBottom: sizes.space / 2,
  },

  link: {
    height: 50,
    alignItems: "center",
    flexDirection: "row-reverse",
    paddingHorizontal: 2 * sizes.space,
  },
});
